import type { QuestionAggregateDto } from "@mmm/contracts";
import { QUESTION_TYPE_LABEL_KEYS } from "../../constants.js";
import { useT } from "@mmm/ui";
const LETTERS = "ABCDEFGHIJ";

interface QuestionCardProps {
  question: QuestionAggregateDto;
  /** Test view (false) shows only the question; Answers view (true) marks the memo. */
  showAnswers: boolean;
}

export function QuestionCard({ question, showAnswers }: QuestionCardProps) {
  const t = useT();
  const options = question.answerOptions.slice().sort((a, b) => a.sortOrder - b.sortOrder);
  const rubric = question.rubricItems.slice().sort((a, b) => a.sortOrder - b.sortOrder);

  return (
    <div className="mmm-card mmm-question-card">
      <div className="mmm-question-head">
        <span className="mmm-question-num">{question.questionNumber}</span>
        <span className="mmm-question-prompt">{question.prompt}</span>
        <span className="mmm-question-type">{t(QUESTION_TYPE_LABEL_KEYS[question.type])}</span>
      </div>

      {question.type === "freeText" ? (
        showAnswers ? (
          <div className="mmm-question-body">
            <div className="mmm-model-answer">
              <span className="mmm-model-answer-label">{t("tests.modelAnswer")}</span>
              {question.correctAnswer}
            </div>
            {rubric.length > 0 && (
              <div className="mmm-rubric">
                {rubric.map((item) => (
                  <div key={item.id} className="mmm-rubric-row">
                    <span>{item.text}</span>
                    <span className="mmm-rubric-points">
                      {t("tests.pointsAbbrev", { count: item.points })}
                    </span>
                  </div>
                ))}
              </div>
            )}
          </div>
        ) : (
          <div className="mmm-question-body">
            <div className="mmm-answer-blank">{t("tests.freeTextAnswer")}</div>
          </div>
        )
      ) : (
        <div className="mmm-question-body">
          {options.map((option, index) => (
            <div
              key={option.id}
              className={`mmm-option-row ${showAnswers && option.isCorrect ? "is-correct" : ""}`.trim()}
            >
              <span className="mmm-option-letter">{LETTERS[index] ?? index + 1}</span>
              <span className="mmm-option-text">{option.text}</span>
              {showAnswers && option.isCorrect && <span className="mmm-option-check">✓</span>}
            </div>
          ))}
        </div>
      )}

      {showAnswers && question.explanation && <p className="mmm-question-explanation">{question.explanation}</p>}
    </div>
  );
}
